module.exports = __webpack_public_path__ + "media/images/popup-phone-number-c6b28e6c.png";